// extracted by mini-css-extract-plugin
export default {"faqs":"DE-z","faqContent":"EE-z","faq":"FE-z"};